import React from 'react';
import BaseClass from '@/pages/BaseClass';

import $ from 'jquery';
import {
	Empty,
	Modal,
	Pagination,
} from 'antd'
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost
} from '@/utils/Tools';

export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'tabIndex':0,
			
			'filter':{
			},
			'list':[],
			'pageInfo':{
				'current':1,
				'total':100,
				'pageSize':9,
			},
			
			'rulePageInfo':{},
			'showRuleDialog':false,
			
			/*
			'couponFilter':{
				'coupon_status':0,
			},
			'couponList':[],
			'couponPageInfo':{
				'current':1,
				'total':100,
				'pageSize':10,
			},
			
			'ruleList':[],
			'rulePageInfo':{
				'current':1,
				'total':100,
				'pageSize':10,
			},
			*/
		};
	}
	
	componentDidMount()
	{
		document.title = '我的优惠券 - ' + CommonValue.get('site_name');
		this.switchTab(0);
	}
	
	switchTab(index)
	{
		this.setState({
			'tabIndex':index,
		},()=>{
			this.getList();
		});
		
		if(index <= 2)
		{
			if(0 == index)
				this.state.filter['real_coupon_status_list'] = [0,1];
			else if(1 == index)
				this.state.filter['real_coupon_status_list'] = [2];
			else if(2 == index)
				this.state.filter['real_coupon_status_list'] = [3];
		}
		else
		{
		}
		
	}
	
	getList(page,pageSize)
	{
		if(this.state.tabIndex <= 2)
		{
			this.getCouponList(page,pageSize);
		}
		else
		{
			this.getRuleList(page,pageSize);
		}
		
	}
	
	getCouponList(page,pageSize)
	{
		if(!page) page = 1;
		if(!pageSize) pageSize = this.state.pageInfo.pageSize;
		
		let url = pcUrl('coupon','index');
		let param = this.state.filter;
		param.page = page;
		param['page_size'] = pageSize;
		
		httpPost(url,param)
			.then(data=>{
				data.list.forEach(row=>{
					row['coupon_start_time_exp'] = row['coupon_start_time_exp'].replace(/\-/g,'.');
					row['coupon_end_time_exp'] = row['coupon_end_time_exp'].replace(/\-/g,'.');
				});
				
				this.setState({
					'list':data['list'],
					'pageInfo':{
						'current':page,
						'total':data['page_info'].total,
						'pageSize':pageSize,
					},
				});
			});
	}
	
	getRuleList(page,pageSize)
	{
		if(!page) page = 1;
		if(!pageSize) pageSize = this.state.pageInfo.pageSize;
		
		let url = pcUrl('coupon','ruleList');
		let param = {};
		param.page = page;
		param['page_size'] = pageSize;
		
		httpPost(url,param)
			.then(data=>{
				data.list.forEach((row,index)=>{
					/*
					row['start_time'] = row['start_time'].split('-');
					row['start_time'] = `${row['start_time'][0]}年${row['start_time'][1]}月${row['start_time'][2]}日`
					
					row['end_time'] = row['end_time'].split('-');
					row['end_time'] = `${row['end_time'][0]}年${row['end_time'][1]}月${row['end_time'][2]}日`
					*/
					row['start_time_exp'] = row['start_time_exp'].replace(/\-/g,'.');
					row['end_time_exp'] = row['end_time_exp'].replace(/\-/g,'.');
				});
				this.setState({
					'list':data['list'],
					'pageInfo':{
						'current':page,
						'total':data['page_info'].total,
						'pageSize':pageSize,
					},
				});
			});
	}
	
	//领取优惠券
	getCoupon(index)
	{
		let info = this.state.list[index];
		
		//未开始
		if(info['real_status'] == 1)
		{
			//message('领取活动未开始');
			return false;
		}
		else if(info['real_status'] == 4)
		{
			return false;
		}
		
		let url = pcUrl('coupon','getCoupon');
		let param = {
			'rule_id':info['rule_id'],
		};
		httpPost(url,param)
			.then(data=>{
				message('优惠券领取成功','success');
				this.getRuleList();
				//this.switchTab(0);
			});
	}
	
	showRulePage()
	{
		let _next = ()=>{
			this.setState({
				'showRuleDialog':true,
			});
		};
		
		if(!this.state.rulePageInfo['article_id'])
		{
			let url = pcUrl('coupon','rulePage');
			httpPost(url)
				.then(data=>{
					this.setState({
						'rulePageInfo':data,
					});
					_next();
				});
		}
		else
			_next();
		
		
	}
	
	render()
	{
		return (
			<div style={{'padding':'2em'}}>
				<div className="coupon">
					<div className="coupon-shift">
						<span className="float-right">
							<a href="javascript:;" onClick={()=>{this.showRulePage();}}>
								优惠券使用规则&gt;&gt;
							</a>
						</span>
						<ul>
							<li>
								<a href="javascript:;" className={(0 == this.state.tabIndex) ? 'now':''} onClick={()=>this.switchTab(0)}>可使用</a>
							</li>
							<li>
								<a href="javascript:;" className={(1 == this.state.tabIndex) ? 'now':''} onClick={()=>this.switchTab(1)}>已使用</a>
							</li>
							<li>
								<a href="javascript:;" className={(2 == this.state.tabIndex) ? 'now':''} onClick={()=>this.switchTab(2)}>已过期</a>
							</li>
							<li>
								<a href="javascript:;" className={(3 == this.state.tabIndex) ? 'now':''} onClick={()=>this.switchTab(3)}>待领取</a>
							</li>
						</ul>
						<div className="clear"></div>
					</div>
					
					<div className="coupon-list">
						{this.state.list.length ? (
							<>
								{this.state.list.map((row,index)=>{
									if(!row['rule_id'])
										return (
											<dl className={['gray','','black','gray'][row['real_coupon_status']]}>
												<dt>
													<span className="small">￥</span>
													{row['coupon_amount']}
												</dt>
												<dd className="desc">
													满{row['min_expense']}元使用
												</dd>
												<dd>
													{row['coupon_start_time_exp']} 0:00 - {row['coupon_end_time_exp']} 0:00
												</dd>
												<dd>
													优惠券号：{row['coupon_sn']}
												</dd>
												<dd className="coupon-right">
													{row['real_coupon_status'] == 0 && (
													<div className="coupon-right-inner">
														<div> 未 </div>
														<div> 开 </div>
														<div> 始 </div>
													</div>
													)}
													{row['real_coupon_status'] == 1 && (
													<div className="coupon-right-inner">
														<div> 立 </div>
														<div> 即 </div>
														<div> 使 </div>
														<div style={{'margin-bottom':'5px'}}> 用 </div>
														<div className="coupon-right-icon">
															<span className="fa fa-angle-right"></span>
														</div>
													</div>
													)}
													{row['real_coupon_status'] == 2 && (
													<div className="coupon-right-inner">
														<div> 已 </div>
														<div> 使 </div>
														<div> 用 </div>
													</div>
													)}
													{row['real_coupon_status'] == 3 && (
													<div className="coupon-right-inner">
														<div> 已 </div>
														<div> 过 </div>
														<div> 期 </div>
													</div>
													)}
												</dd>
											</dl>
										);
									else
										return (
											<dl className={['','black','green','','gray'][row['real_status']]} onClick={()=>this.getCoupon(index)}>
												<dt>
													<span className="small">￥</span>
													{row['coupon_amount']}
												</dt>
												<dd className="desc">
													满{row['min_expense']}元使用
												</dd>
												<dd>
													领取日期：
												</dd>
												<dd>
													{row['start_time_exp']} - {row['end_time_exp']}
												</dd>
												<dd className="coupon-right">
													{row['real_status'] == 1 && (
														<div className="coupon-right-inner">
															<div> 未 </div>
															<div> 开 </div>
															<div> 始 </div>
														</div>
													)}
													{row['real_status'] == 2 && (
														<div className="coupon-right-inner">
															<div> 待 </div>
															<div> 领 </div>
															<div> 取 </div>
														</div>
													)}
													{row['real_status'] == 4 && (
														<div className="coupon-right-inner">
															<div> 已 </div>
															<div> 领 </div>
															<div> 取 </div>
														</div>
													)}
												</dd>
											</dl>
										);
								})}
								<div className="clear"></div>
								<div style={{'display':'flex','justify-content':'center','margin':'16px 0'}}> <Pagination {...this.state.pageInfo} onChange={(page,pageSize)=>this.getList(page,pageSize)} /> </div>
							</>
						):(
							<div style={{'padding':'2em'}}>
								<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
							</div>
						)}
						<div className="clear"></div>
					</div>
				</div>
				<Modal
					title="优惠券使用规则"
					width={900}
					visible={this.state.showRuleDialog}
					footer={null}
					onCancel={()=>this.setState({'showRuleDialog':false})}
					>
					<div dangerouslySetInnerHTML={{'__html':this.state.rulePageInfo['content']}}>
						
					</div>
				</Modal>
			</div>
		);
	}
}

